import React, { useEffect, useRef } from 'react';
import { cx } from 'linaria';
import { akinatorItemsWrap, akinatorWrap } from './styles';
import { useSearchHistoryContext } from '../../hooks';
import { AkinatorHistoryButton } from './akinator-history-button';
import { AkinatorClearHistoryButton } from './akinator-clear-history-button';

export const Akinator: React.FC = () => {
  const { history } = useSearchHistoryContext();
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;

    const onWheel = (event: WheelEvent) => {
      if (el.scrollWidth <= el.clientWidth) return;
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

      event.preventDefault();
      el.scrollLeft += event.deltaY;
    };

    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, [history.length]);

  if (!history.length) return null;

  return (
    <div ref={wrapRef} className={akinatorWrap} data-qa="akinator">
      <div className={cx(akinatorItemsWrap)}>
        <AkinatorClearHistoryButton />
        {history.map((i, index) => (
          <AkinatorHistoryButton item={i} index={index} key={`${i.title}_${i.url}`} />
        ))}
      </div>
    </div>
  );
};
